import React from 'react'
import styles from "styles/pages/Pages.module.scss";

export const RenderUnit = (unit, rowPosition, hanndleSelectId, id) => (
        <div 
            key={unit.id} 
            className={`${styles.containerUnit} ${unit.id === id && styles.select}`} 
            style={{ gridColumn: '3', gridRow: rowPosition }}
            onClick={() => hanndleSelectId(unit.id)}
        >
            <div className={styles.containerUnitData}>
                <span className={styles.unitText}>{unit.name}</span>
            </div>
        </div>
    );
